import React from 'react';
import cn from 'classnames';

import { IMetaProps } from './Meta.types';

import './Meta.scss';

const Meta: React.FC<IMetaProps> = ({ message, className }) => (
	<span
		className={cn('f5gMetaMessage', className)}
		data-testid='f5g-meta'
	>
		{message}
	</span>
);

export default Meta;
